module.exports = __webpack_public_path__ + "84a403464480a0646da249c7780a9ee6.svg";